"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations.validations;
  }
});
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/web.url.js");
require("core-js/modules/es.array.filter.js");
var _formElements = require("@evidation/form-elements");
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _blueimpLoadImage = _interopRequireDefault(require("blueimp-load-image"));
var _constants = require("../../constants");
var _utils = require("../../utils");
var _components = require("../../components/uploader/components");
var _preview = _interopRequireDefault(require("../../components/uploader/preview"));
var _components2 = require("./components");
var _i18n = require("../../i18n");
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../../contexts/LanguageContext");
var _validations = require("./validations");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var formatAccept = function formatAccept(accept) {
  var formats = _lodash["default"].split(accept, ', ');
  return _lodash["default"].map(formats, function (f) {
    return _lodash["default"].last(_lodash["default"].split(f, '/')).toUpperCase();
  }).join(', ');
};
var FileUploader = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(FileUploader, _PureComponent);
  var _super = _createSuper(FileUploader);
  function FileUploader(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FileUploader);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "formatFileStr", function (n) {
      return _this.props.t('fields.fileUpload.numberFiles', {
        count: n
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "formatFileNumErr", function (n) {
      return _this.props.t('fields.fileUpload.formatFileNumError', {
        number: n
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "formatFileReqErr", function (max_size) {
      return _this.props.t('fields.fileUpload.fileSizeError', {
        size: (0, _utils.formatBytes)(max_size)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDrop", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(accepted, rejected) {
        var max_files, newAccepted;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                max_files = _this.state.config.max_files;
                _context.next = 3;
                return _this.preprocessFiles(accepted);
              case 3:
                newAccepted = _lodash["default"].slice(_lodash["default"].concat(_this.state.accepted, accepted), 0, max_files);
                _this.setState({
                  accepted: newAccepted,
                  error: _this.formatError(accepted, rejected)
                }, function () {
                  _this.props.input.onChange(newAccepted);
                  _this.props.input.onBlur();
                });
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "preprocessFiles", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(files) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Promise.all(_lodash["default"].compact(files.map(function (file) {
                  // update preview in-place
                  if (_lodash["default"].startsWith(file.type, 'image')) return _this.fixOrientation(file);
                }))));
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixOrientation", function (file) {
      return new Promise(function (resolve) {
        (0, _blueimpLoadImage["default"])(file, function (img) {
          return resolve(img);
        }, {
          orientation: true
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "formatError", function (accepted, rejected) {
      var _this$state$config = _this.state.config,
        accept = _this$state$config.accept,
        max_files = _this$state$config.max_files,
        max_size = _this$state$config.max_size;
      var error;
      if (rejected.length > 0) {
        error = _this.formatFileReqErr(max_size, accept);
      }
      if (accepted.length + _this.state.accepted.length > max_files) {
        error = _this.formatFileNumErr(max_files - _this.state.accepted.length);
      }
      return error;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderDropZone", function () {
      var _this$state$config2 = _this.state.config,
        accept = _this$state$config2.accept,
        max_files = _this$state$config2.max_files,
        max_size = _this$state$config2.max_size;
      var t = _this.props.t;
      var shouldDisplay = _this.state.accepted.length < max_files;
      return shouldDisplay && /*#__PURE__*/_react["default"].createElement(_components.DropzoneContainer, null, /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        id: "t-dropzone",
        style: {},
        accept: accept,
        onDrop: _this.onDrop,
        disabled: _this.state.accepted.length >= max_files || _this.props.disabled,
        maxSize: max_size
      }, /*#__PURE__*/_react["default"].createElement("p", null, t('fields.fileUpload.selectDropFile', {
        maxFileCount: _this.formatFileStr(max_files)
      }), /*#__PURE__*/_react["default"].createElement("br", null), t('fields.fileUpload.formatAccepted', {
        formatAccept: formatAccept(accept)
      }))));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPreviews", function () {
      var accepted = _this.state.accepted;
      return /*#__PURE__*/_react["default"].createElement(_components.PreviewContainer, null, _lodash["default"].map(accepted, function (f, i) {
        return /*#__PURE__*/_react["default"].createElement(_preview["default"], {
          key: f.name,
          img: _lodash["default"].startsWith(f.type, 'image') ? f.preview : undefined,
          disabled: _this.props.disabled,
          onClick: !_this.props.disabled ? function () {
            return _this.onCancel(i);
          } : function () {}
        });
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCancel", function (index) {
      var accepted = _this.state.accepted;

      // destroy unused preview obj to avoid memory leaks
      window.URL.revokeObjectURL(accepted[index].preview);
      _this.setState({
        accepted: _lodash["default"].filter(accepted, function (f, i) {
          return i !== index;
        }),
        error: undefined
      }, function () {
        _this.props.input.onChange(_lodash["default"].filter(_this.props.input.value, function (f, i) {
          return i !== index;
        }));
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderError", function () {
      var error = _this.state.error;
      var _this$props$meta = _this.props.meta,
        validationError = _this$props$meta.error,
        touched = _this$props$meta.touched;
      return touched && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error || validationError);
    });
    var _this$props$config = _this.props.config,
      _this$props$config$ac = _this$props$config.accept,
      _accept = _this$props$config$ac === void 0 ? "image/jpeg, image/png" : _this$props$config$ac,
      _this$props$config$mi = _this$props$config.min_files,
      min_files = _this$props$config$mi === void 0 ? _constants.defaultMinFiles : _this$props$config$mi,
      _this$props$config$ma = _this$props$config.max_files,
      _max_files = _this$props$config$ma === void 0 ? _constants.defaultMaxFiles : _this$props$config$ma,
      _this$props$config$ma2 = _this$props$config.max_size,
      _max_size = _this$props$config$ma2 === void 0 ? _constants.defaultMaxFileSize : _this$props$config$ma2;
    _this.state = {
      accepted: [],
      error: undefined,
      config: {
        accept: _accept,
        min_files: min_files,
        max_files: _max_files,
        max_size: _max_size
      }
    };
    return _this;
  }

  // each drop or upload has separate accepted files

  // TODO support other file types
  (0, _createClass2["default"])(FileUploader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        labelStyle = _this$props.labelStyle,
        label = _this$props.label,
        required = _this$props.required,
        submitting = _this$props.meta.submitting;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        labelStyle: labelStyle,
        label: label,
        required: required
      }, /*#__PURE__*/_react["default"].createElement(_components2.UploadingOverlay, {
        active: submitting
      }, this.renderDropZone(), this.renderPreviews(), this.renderError())));
    }
  }]);
  return FileUploader;
}(_react.PureComponent);
FileUploader.propTypes = {
  config: (0, _propTypes.shape)({
    accept: _propTypes.string,
    max_files: _propTypes.number,
    max_size: _propTypes.number,
    bucket: _propTypes.string.isRequired
  })
};
FileUploader.defaultProps = {};
var _default = exports["default"] = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(FileUploader);